<template>
    <div class="table-settings">
        <h2 class="subtitle">{{title}} Table</h2>

        <p class="help">Check the columns you want visible, then drag a row to reorder it.</p>

        <div class="has-text-right">
            <div class="button is-primary" @click="handleSave">
                Save
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <label class="label">Available Columns</label>

                <draggable v-model="localColumns"
                           item-key="field"
                           tag="div"
                           :animation="150"
                           ghost-class="draggable-item-ghost"
                >
                  <template #item="{element}">
                    <div class="draggable-item">
                      <div class="left">
                        <o-checkbox v-model="element.visible">
                          {{element.label}}
                        </o-checkbox>
                      </div>
                      <div class="right">
                        <span class="handle" aria-hidden="true">↕</span>
                      </div>
                    </div>
                  </template>
                </draggable>

            </div>
        </div>

        <div class="has-text-right">
            <div class="button is-primary" @click="handleSave">
                Save
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

  import {ref, onMounted, watch, toRefs} from "vue";

  import draggable from 'vuedraggable';
  import Column, {type ColumnType} from "@/use/Column";

  let localColumns = ref<ColumnType[]>([]);

  interface TableSettings {
    columns: Column[],
  }

  const props = withDefaults(defineProps<{
    availableColumns: Column[],
    title: string,
  }>(), {
    availableColumns: [],
    title: '',
  });
  const {
    availableColumns,
    title,
  } = toRefs(props);

  const emit = defineEmits<{
    'saved': [TableSettings],
  }>();

  onMounted(() => {
    setLocalColumns();
  });

  function handleSave() {
    const tableSettings: TableSettings = {
      columns: localColumns.value.map((column, i) => {
        return {
          ...column,
          rank: i + 1
        };
      }),
    };

    emit('saved', tableSettings);
  }

  function setLocalColumns() {
    localColumns.value = [
      ...availableColumns.value.map(column => { return { ...column }}).sort((a, b) => {
        if (a.rank > b.rank) return 1;
        else if (a.rank < b.rank) return -1;
        else return 0;
      }),
    ];
  }

  watch(availableColumns, () => {
    setLocalColumns();
  });

</script>

<style lang="scss" scoped>
.draggable-item {
  cursor: grab;
}

.draggable-item:active {
  cursor: grabbing;
}

.draggable-item-ghost {
  opacity: 0.45;
}

.handle {
  color: $grey;
  font-size: 1.125rem;
  line-height: 1;
}
</style>
